import styled from "styled-components";

export const StyledTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  border-radius: 10px;
  width: 30px;
  height: 30px;
`;
